export const ruleReprocessingStatus = {
  complete: 'COMPLETE',
  pending: 'PENDING',
  error: 'ERROR',
};

// 1500 ms delay for polling reprocessing status
export const reprocessPollingDelay = 1500;

// 60,000 ms timeout for polling, process errors if not complete by this time
export const reprocessPollingTimeout = 60000;
